import { Col, Container, Row } from 'react-bootstrap';
import styled, { useTheme } from 'styled-components';

import MainNav from '../../MainNav';

import StyledNavbar from './Branded/StyledNavbar';

const DefaultStyledContainer = styled(Container)`
  background-color: ${(props) => props.theme.colors.pale};
`;

const BrandedLoginLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <DefaultStyledContainer fluid className="d-flex flex-column justify-content-between login-background">
      {theme.layout.showOrHideElements.auth.signUp.showMainNavOnLogin && (
        <Row>
          <Col className="p-0">
            <StyledNavbar collapseOnSelect expand="lg">
              <Container fluid="xl">
                <MainNav isLoginScreen={true} />
              </Container>
            </StyledNavbar>
          </Col>
        </Row>
      )}
      <Row className="p-lg-5 p-md-4 p-3 mb-5 justify-content-center">{children}</Row>
      <Row>{/* This empty row is here so flex-box keeps the login card vertically centred */}</Row>
    </DefaultStyledContainer>
  );
};

export default BrandedLoginLayout;
